var $b983ca1383d5b960$exports = {};
$b983ca1383d5b960$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `N\xe1stroj na zmenu ve\u{13E}kosti`,
    "colorSwatchPicker": `Color swatches`
};


export {$b983ca1383d5b960$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
